import { defineMessages } from 'react-intl';
import { ActionType } from './action-type';

export const messages = defineMessages({
  [ActionType.Email]: {
    description: 'Message required to create an automation rule for Email Notification',
    defaultMessage: 'Email',
    id: 'NE7lcB',
  },
  [ActionType.Sms]: {
    description: 'Message required to create an automation rule for SMS Notification',
    defaultMessage: 'SMS',
    id: 'EwLfIx',
  },
});
